import { ALL_HOLDINGS, EXPORT_HOLDINGS_OPTION, HOLDINGS_HISTORY_TABLE_HEADER_DROPDOWN_CONFIG, SAVE_AS_WATCHLIST_OPTION, } from 'SecuritiesApp/ts/constants/holdings-table.constants';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import { HoldingsTableDirective } from 'SecuritiesApp/ts/directives/holdings-table.directive';
import { formatUTCDateString } from 'Core/redesign/utils/date';
import { getFormatter } from 'NewAngular/utils/number_formatter';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "SecuritiesApp/ts/services/securities.service";
import * as i3 from "@angular/common";
import * as i4 from "../holdings-date-picker-inline/holdings-date-picker-inline.component";
import * as i5 from "../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i6 from "../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i7 from "../../../../../../../ycharts/static/ts/features/components/dropdowns/cascading-dropdown/cascading-dropdown.component";
import * as i8 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i9 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i10 from "../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
function HoldingsHistoryTableComponent_tr_23_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "a", 32);
} if (rf & 2) {
    const holding_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", holding_r1.url, i0.ɵɵsanitizeUrl)("text", holding_r1.ticker);
} }
function HoldingsHistoryTableComponent_tr_23_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const holding_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(holding_r1.ticker);
} }
function HoldingsHistoryTableComponent_tr_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtemplate(2, HoldingsHistoryTableComponent_tr_23_a_2_Template, 1, 2, "a", 28)(3, HoldingsHistoryTableComponent_tr_23_span_3_Template, 2, 1, "span", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "td", 30)(5, "td", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const holding_r1 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", holding_r1.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !holding_r1.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", holding_r1.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", holding_r1.current_weight);
} }
function HoldingsHistoryTableComponent_ycn_loading_symbol_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 33);
} }
/**
 * HoldingsHistoryComponent
 *
 * Displays all holdings data from a user-selected month and year for a fund.
 *
 * Input Properties:
 *   securityId: the securityId of the fund to show holdings for
 *   displaySecurityId: the displaySecurityId of the fund to show holdings for
 *   initialHoldingDate: The date to initially show all holdings data for
 *   holdingDates: List of all dates the fund has all holdings data for
 */
export class HoldingsHistoryTableComponent extends HoldingsTableDirective {
    constructor(featuresService, securitiesService) {
        super(featuresService, securitiesService);
        this.featuresService = featuresService;
        this.securitiesService = securitiesService;
        this.actionsDropdownConfig = HOLDINGS_HISTORY_TABLE_HEADER_DROPDOWN_CONFIG;
    }
    ngOnInit() {
        this.type = ALL_HOLDINGS;
        this.currentHoldingDate = this.initialHoldingDate;
        this.validHoldingDates = this.holdingDates;
        this.getHoldings();
    }
    formatHoldings(holdings) {
        const valFormatter = getFormatter('percent');
        return holdings.map((holding) => {
            const formattedHolding = { ...holding };
            const currentWeight = formattedHolding.current_weight;
            formattedHolding.current_weight = currentWeight ? valFormatter(currentWeight, 2) : '--';
            formattedHolding.ticker = holding.ticker ? holding.ticker : '--';
            return formattedHolding;
        });
    }
    selectDropdownOption(option) {
        switch (option) {
            case SAVE_AS_WATCHLIST_OPTION:
                this.saveAsWatchlist();
                break;
            case EXPORT_HOLDINGS_OPTION:
                this.exportHoldingDataUrl(formatUTCDateString(this.currentHoldingDate));
                break;
            default:
                break;
        }
    }
}
HoldingsHistoryTableComponent.ɵfac = function HoldingsHistoryTableComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsHistoryTableComponent)(i0.ɵɵdirectiveInject(i1.FeatureService), i0.ɵɵdirectiveInject(i2.SecuritiesService)); };
HoldingsHistoryTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HoldingsHistoryTableComponent, selectors: [["ycn-holdings-history-table"]], inputs: { securityId: "securityId", displaySecurityId: "displaySecurityId", initialHoldingDate: "initialHoldingDate", holdingDates: "holdingDates" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 44, vars: 18, consts: [[1, "panel", "panel-data"], [1, "panel-header", "panel-header-multiactions"], [1, "panel-title"], [1, "panel-actions"], [3, "dateChangeHandler", "dateOptions", "initialSelectedDate"], [1, "panel-action", "dropdown"], ["buttonClass", "options-handler btn btn-xs btn-circle btn-transparent", "dropdownClass", "dropdown-menu-right dropdown-menu-with-icons", 3, "handler", "showDropdownCaret", "config"], [1, "panel-scroll"], [1, "panel-content"], [1, "table"], [2, "cursor", "pointer", "user-select", "none"], ["data-test-id", "Column Headers"], [3, "click", "ngClass"], [2, "padding-top", "0", "padding-bottom", "0"], [1, "colTxtShort", "text-right", 3, "click", "ngClass"], [4, "ngFor", "ngForOf"], [1, "panel-action"], [1, "panel-results-count"], ["ycnDisabled", "", "data-test-id", "Prev Button", 1, "btn", "btn-secondary", 3, "click", "disabled"], ["ycnDisabled", "", "data-test-id", "Next Button", 1, "btn", "btn-secondary", 3, "click", "disabled"], ["loaderMessage", "Loading Data...", 4, "ngIf"], ["data-test-id", "Save As Watchlist Result", 3, "closeModalHandler", "extraModalClasses", "open"], ["header", "Save as Watchlist", 3, "closeModalHandler"], [1, "modal-body"], [1, "modal-section", "section-info", 3, "textContent"], [1, "modal-footer", "user-select-none"], [1, "modal-footer-actions"], [1, "btn", "btn-text", 3, "click"], [3, "href", "text", 4, "ngIf"], [4, "ngIf"], [3, "textContent"], [1, "text-right", 3, "textContent"], [3, "href", "text"], ["loaderMessage", "Loading Data..."]], template: function HoldingsHistoryTableComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3)(5, "ycn-holdings-date-picker-inline", 4);
        i0.ɵɵlistener("dateChangeHandler", function HoldingsHistoryTableComponent_Template_ycn_holdings_date_picker_inline_dateChangeHandler_5_listener($event) { return ctx.handleDateChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5)(7, "ycn-cascading-dropdown", 6);
        i0.ɵɵlistener("handler", function HoldingsHistoryTableComponent_Template_ycn_cascading_dropdown_handler_7_listener($event) { return ctx.selectDropdownOption($event); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(8, "div", 7)(9, "div", 8)(10, "table", 9)(11, "thead", 10)(12, "tr", 11)(13, "th", 12);
        i0.ɵɵlistener("click", function HoldingsHistoryTableComponent_Template_th_click_13_listener() { return ctx.setTableSortProperties("ticker"); });
        i0.ɵɵelementStart(14, "span", 13);
        i0.ɵɵtext(15, " Symbol ");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(16, "th", 12);
        i0.ɵɵlistener("click", function HoldingsHistoryTableComponent_Template_th_click_16_listener() { return ctx.setTableSortProperties("name"); });
        i0.ɵɵelementStart(17, "span", 13);
        i0.ɵɵtext(18, " Name ");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(19, "th", 14);
        i0.ɵɵlistener("click", function HoldingsHistoryTableComponent_Template_th_click_19_listener() { return ctx.setTableSortProperties("current_weight"); });
        i0.ɵɵelementStart(20, "span", 13);
        i0.ɵɵtext(21, " %\u00A0Weight ");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(22, "tbody");
        i0.ɵɵtemplate(23, HoldingsHistoryTableComponent_tr_23_Template, 6, 4, "tr", 15);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(24, "div", 3)(25, "div", 16)(26, "span", 17);
        i0.ɵɵtext(27);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(28, "div", 16)(29, "button", 18);
        i0.ɵɵlistener("click", function HoldingsHistoryTableComponent_Template_button_click_29_listener() { return ctx.pageChangeHandler(ctx.PAGE_CONTROLS.PREV); });
        i0.ɵɵtext(30, " Prev ");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(31, "div", 16)(32, "button", 19);
        i0.ɵɵlistener("click", function HoldingsHistoryTableComponent_Template_button_click_32_listener() { return ctx.pageChangeHandler(ctx.PAGE_CONTROLS.NEXT); });
        i0.ɵɵtext(33, " Next ");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵtemplate(34, HoldingsHistoryTableComponent_ycn_loading_symbol_34_Template, 1, 0, "ycn-loading-symbol", 20);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(35, "ycn-modal-base", 21);
        i0.ɵɵlistener("closeModalHandler", function HoldingsHistoryTableComponent_Template_ycn_modal_base_closeModalHandler_35_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(36, "ycn-simple-modal-header", 22);
        i0.ɵɵlistener("closeModalHandler", function HoldingsHistoryTableComponent_Template_ycn_simple_modal_header_closeModalHandler_36_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(37, "div", 23);
        i0.ɵɵelement(38, "div", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(39, "div", 25)(40, "div", 26)(41, "div", 27);
        i0.ɵɵlistener("click", function HoldingsHistoryTableComponent_Template_div_click_41_listener() { return ctx.closeModal(); });
        i0.ɵɵtext(42, " Close ");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(43, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1("", ctx.displaySecurityId, " Holdings");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("dateOptions", ctx.validHoldingDates)("initialSelectedDate", ctx.currentHoldingDate);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("showDropdownCaret", false)("config", ctx.actionsDropdownConfig);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngClass", ctx.getSortNgClass("ticker"));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", ctx.getSortNgClass("name"));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", ctx.getSortNgClass("current_weight"));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngForOf", ctx.formattedHoldings);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate3("", ctx.paginationInfo.start_index, " -", ctx.paginationInfo.end_index, " of ", ctx.paginationInfo.num_items, " items");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.pageNum === 1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", ctx.pageNum === ctx.paginationInfo.num_pages);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("extraModalClasses", "modal-sm")("open", ctx.showSaveAsWatchlistResult);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("textContent", ctx.saveAsWatchlistResult);
    } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i4.HoldingsDatePickerInlineComponent, i5.DisabledDirective, i6.LoadingSymbolComponent, i7.CascadingDropdownComponent, i8.ModalBaseComponent, i9.SimpleModalHeaderComponent, i10.FeatureNeededComponent], encapsulation: 2 });
